export const en = {
  mainTitle: 'What can we help you with?',
  backToHelpCenter: 'Back to help center',
  contactUs: 'Contact us',
  needFurtherAssistance: 'Need further assistance or can\'t find what you\'re looking for?',
  wasThisArticleHelpful: 'Was this article helpful?',
  yes: 'Yes',
  no: 'No',
  tscHelpCenter: 'TSC Help Center',
  browseByHelpTopics: 'Browse by help topics',
  stillNeedHelp: 'Still need help?',
  weOfferLiveChatAssistance: 'We offer Live Chat assistance',
  liveChatDate: 'Monday - Sunday: 7:00am EST to 12:00am EST',
  liveChat: 'Live Chat',
  customerCareRepresentative: 'To speak to a Customer Care Representative call our',
  customerServiceCenter: 'Customer Service Center',
  emailSupport: 'We also offer 24/7 email support',
  sendUsEmail: 'Send us an email',
  topCustomerQuestions: 'Top customer questions',
  showingResults: 'Showing {{count}} results for "{{searchTerm}}"',
  noResult: 'We could not find anything for',
  searchAgain: 'Please search again using a different term',
  seeMore: 'See more',
  seeLess: 'See less',
  contactInfoTitle: 'Contact Info',
  chatWithOurCustomerService: 'Chat with our Customer Service',
  chatWithOurCustomerServiceDate: 'Monday - Sunday: 7:00am EST to 12:00am EST',
  callOurCustomerServiceTeam: 'Call our Customer Service Team at 1-888-2020-888',
  callOurCustomerServiceTeamDate: 'Monday - Friday: 9:00am to 9:00pm EST',
  callOurCustomerServiceTeamDate2: 'Saturday - Sunday: 9:00am to 6:00pm EST',
  callOurSalesTeam: 'Call our Sales Team at 1-888-2020-888',
  callOurSalesTeamDate: 'Monday - Sunday: 7:00am to 2:00am EST',
  contactUsInquiryText: 'For any email inquiries please complete our email forms below.',
  generalEmailInquiriesText: 'General email inquiries',
  billingRefundEmailInquiriesText: 'Billing/refund email inquiries',
  ifYouLikeToSendUsFeedback: 'If you\'d like to send us feedback, please complete our',
  feedbackForm: 'Feedback form',
  contactFormGeneralInquiriesTitle: 'General email inquiries',
  forAnyGeneralInquiries: 'For any general inquiries please fill out the email form below:',
  contactFormBillingAndRefundInquiriesTitle: 'Billing or Refund Inquiries',
  contactFormSendFeedbackTitle: 'Send feedback',
  required: 'Required fields are marked with an asterisk(*)',
  emailAddress: 'Email address *',
  emailAddressInfo: 'We need this email to communicate back with you.',
  firstName: 'First name *',
  lastName: 'Last name *',
  phoneNumber: 'Phone number *',
  concerns: 'Concerns *',
  submit: 'Submit',
  contactFormInformation1: 'For immediate assitance contact our',
  contactFormInformation2: 'Live Chat Team',
  contactFormInformation3: 'or call our Customer Service line at',
  contactFormInformation4: 'available from 7:00am to 12:00am, seven days a week.',
  contactTsc: 'Contact TSC',
  contactInfo: 'Contact info',
  emailInquiry: 'General email inquiries',
  billingRefundInquiry: 'Billing/refund inquiries',
  sendFeedback: 'Send feedback',
  submissionReceived: 'Thank you for your email! Your submission has been received',
  weWillSendYouAnEmail: 'We will send you an email with your case number for reference within the next 10 minutes',
  weAimToGetBack: 'We aim to get back to you within 72 hours.',
  theTscCustomerCareTeam: 'The TSC Customer Care Team',
  pleaseClickOnTheFollowingLinkTo: 'Please click on the following link to',
  continueShopping: 'Continue shopping',
  ifYouHaventReceievedOurEmail: '*If you haven\'t received our email within 15 minutes, please check your spam folder too',
  somethingWentWrongOnOurEnd: 'We\'re sorry something went wrong on our end.',
  pleaseSendUsYourConcerns: 'Please send us your concerns via our live chat or call us at',
  thankYou: 'Thank you,',
  pleaseEnterYourEmailAddressInTheFormat: 'Please enter your email address in the format john@example.com',
  orderNumber: 'Order Number *',
  validOrderNumberIsRequired: 'Valid order number is required',
  firstNameValidation: 'Required and numbers and special characters are not allowed',
  lastNameValidation: 'Required and numbers and special characters are not allowed',
  phoneValidation: 'Please enter your 10 digit phone number, including your area code',
  concernValidation: 'Concerns are required',
  //Desc
  searchHelpCenter: 'Search Help Center',
  provideFeedbackDesc1: 'Please visit our',
  provideFeedbackDesc1Link: 'Support Page',
  provideFeedbackDesc2: 'for general inquires & FAQ\'\s',
  bilingOrRefundInquiriesDesc1: 'For refunds, please check our',
  bilingOrRefundInquiriesDesc1Link: 'Refunds page', 
  bilingOrRefundInquiriesDesc2: 'For any other billing request, contact our',
  bilingOrRefundInquiriesDesc2Link: 'Live Chat Team',
  bilingOrRefundInquiriesDesc3: '! from 7am to midnight, seven days a week, or send us an email below.',
  otherDesc: 'Please visit our FAQ page'
};


export const fr = {
  mainTitle: 'Comment pouvons-nous vous aider?',
  backToHelpCenter: 'Retour au centre d\'aide',
  contactUs: 'Contactez-Nous',
  needFurtherAssistance: 'Avez-vous besoin d\'aide supplémentaire ou vous ne trouvez pas ce que vous cherchez',
  wasThisArticleHelpful: 'Was this article helpful?',
  yes: 'Oui',
  no: 'Non',
  tscHelpCenter: 'Centre d\'aide TSC',
  browseByHelpTopics: 'Parcourir par thèmes d\'aide',
  stillNeedHelp: 'Encore besoin d\'aide?',
  weOfferLiveChatAssistance: 'Nous proposons une assistance par discussion en direct',
  liveChatDate: 'Lundi - dimanche : 7 h à 12 h (HE)',
  liveChat: 'Discussions en direct',
  customerCareRepresentative: 'Pour parler à un représentant du service clientèle, appelez notre',
  customerServiceCenter: 'Centre de service à la clientèle',
  emailSupport: 'Nous offrons également une assistance par courriel 24/7',
  sendUsEmail: 'Envoyez-nous un courriel',
  topCustomerQuestions: 'Questions les plus fréquentes',
  showingResults: 'Afficher les résultats de {{count}} pour "{{searchTerm}}"',
  noResult: 'Nous n\'avons rien trouvé pour',
  searchAgain: 'Veuillez effectuer une nouvelle recherche en utilisant un terme différent',
  seeMore: 'Voir plus',
  seeLess: 'Voir moins',
  contactInfoTitle: 'Informations de contact',
  chatWithOurCustomerService: 'Parlez avec notre service clientèle',
  chatWithOurCustomerServiceDate: 'Lundi - dimanche : 7 h à 12 h (HE)',
  callOurCustomerServiceTeam: 'Appelez notre équipe de service à la clientèle au 1-888-2020-888.',
  callOurCustomerServiceTeamDate: 'Lundi - vendredi : 9 h à 21 h (HE)',
  callOurCustomerServiceTeamDate2: 'Samedi - dimanche : 9 h à 18 h (HE)',
  callOurSalesTeam: 'Appelez notre équipe de vente au 1-888-2020-888',
  callOurSalesTeamDate: 'Du lundi au dimanche : de 7 h à 2 h (HE)',
  contactUsInquiryText: 'Pour toutes les demandes de renseignements par courriel, veuillez remplir nos formulaires de courriel ci-dessous.',
  generalEmailInquiriesText: 'Demandes générales par courriel',
  billingRefundEmailInquiriesText: 'Demandes de Facturation et de Remboursement',
  ifYouLikeToSendUsFeedback: 'Si vous souhaitez nous faire part de vos commentaires, veuillez remplir notre formulaire de commentaires.',
  feedbackForm: 'Formulaire de commentaires',
  contactFormGeneralInquiriesTitle: 'Demandes générales par courriel',
  forAnyGeneralInquiries: 'Pour toute question générale, veuillez remplir le formulaire ci-dessous:',
  contactFormBillingAndRefundInquiriesTitle: 'Demandes de Facturation et de Remboursement',
  contactFormSendFeedbackTitle: 'Envoyez vos commentaires',
  required: 'Champs obligatoires sont indiqués par un astérisque (*)',
  emailAddress: 'Adresse courriel *',
  emailAddressInfo: 'Nous avons besoin de ce courriel pour vous communiquer votre commande.',
  firstName: 'Prénom *',
  lastName: 'Nom de famille *',
  phoneNumber: 'Numéro de téléphone *',
  concerns: 'Concernes *',
  submit: 'Soumettre',
  contactFormInformationFirst: 'Pour toute assistance immédiate, contactez notre équipe de discussion en direct ou appelez notre service clientèle au numéro suivant',
  contactFormInformationSecond: 'Disponible de 7 h à 12 h, sept jours sur sept.',
  contactTsc: 'Contacter TSC',
  contactInfo: 'Informations de contact',
  emailInquiry: 'Demandes générales par courriel',
  billingRefundInquiry: 'Demandes de Facturation et de Remboursement',
  sendFeedback: 'Envoyez vos commentaires',
  submissionReceived: 'Merci pour votre email! Merci pour votre email!',
  weWillSendYouAnEmail: 'Nous vous enverrons un courriel avec votre numéro de dossier pour référence dans les 10 prochaines minutes',
  weAimToGetBack: 'Nous nous efforçons de vous répondre dans les 72 heures.',
  theTscCustomerCareTeam: 'L\'équipe du service clientèle de TSC.',
  pleaseClickOnTheFollowingLinkTo: 'Veuillez cliquer sur le lien suivant pour',
  continueShopping: 'Continuer vos achats.',
  ifYouHaventReceievedOurEmail: '* Si vous n\'avez pas reçu notre courrier électronique dans les 15 minutes, veuillez également vérifier votre dossier de courrier indésirable.',
  somethingWentWrongOnOurEnd: 'Nous sommes désolés, quelque chose a mal tourné de notre côté.',
  pleaseSendUsYourConcerns: 'Veuillez nous faire part de vos préoccupations via notre discussion en direct ou appelez-nous au',
  thankYou: 'Merci,',
  pleaseEnterYourEmailAddressInTheFormat: 'Veuillez saisir votre adresse e-mail au format john@example.com',
  orderNumber: 'Numéro de commande',
  validOrderNumberIsRequired: 'Un numéro de commande valide est requis.',
  firstNameValidation: 'Obligatoire et les chiffres et les caractères spéciaux ne sont pas autorisés.',
  lastNameValidation: 'Obligatoire et les chiffres et les caractères spéciaux ne sont pas autorisés.',
  phoneValidation: 'Veuillez entrer votre numéro de téléphone de 10 chiffres, y compris le code régional',
  concernValidation: 'Des préoccupations sont requises',
  searchHelpCenter: 'Centre d\'aide à la recherche',
  //Desc
  provideFeedbackDesc1: 'Veuillez visiter notre',
  provideFeedbackDesc1Link: 'Page de Soutien',
  provideFeedbackDesc2: 'pour les questions générales et les FAQ',
  bilingOrRefundInquiriesDesc1: 'Pour les remboursements, veuillez consulter notre',
  bilingOrRefundInquiriesDesc1Link: 'page Remboursements', 
  bilingOrRefundInquiriesDesc2: 'Pour toute autre demande de facturation, contactez notre',

  contactFormInformation1: 'Pour toute assistance immédiate, contactez notre',
  contactFormInformation2: 'équipe de discussion en direct ',
  contactFormInformation3: 'ou appelez notre service clientèle au numéro suivant',
  contactFormInformation4: 'Disponible de 7 h à 12 h, sept jours sur sept.',
  bilingOrRefundInquiriesDesc2Link: 'équipe de discussion en direct ',
  bilingOrRefundInquiriesDesc3: '! de 7h à minuit, sept jours sur sept, ou envoyez-nous un e-mail ci-dessous.',
  otherDesc: 'Veuillez visiter notre page FAQ'
};